import React from 'react';
import PropTypes from 'prop-types';

import Progress from 'components/progress/circle';
import { USD } from 'helpers/formatters/number_formats';
import { brokerColors, outsideCommissionsColor } from 'helpers/charts/backoffice/voucher_palette';

export default function BrokerCommission({ commission, index, transactionSide }) {
  let dataSource;
  if (transactionSide) {
    dataSource = commission.transactionSideDetails.find(details => details.transactionSide === transactionSide);
  } else {
    dataSource = commission;
  }

  return (
    <div className="commission d-flex align-items-center gap-2">
      <Progress
        color={commission.outside ? outsideCommissionsColor : brokerColors[index]}
        fontSize={12}
        percent={dataSource.grossPercent}
        size={48}
      />

      <div className="d-flex flex-column">
        <div>{USD.format(dataSource.grossAmount)}</div>
        <div className="text-muted fs-small">Gross Commission</div>
      </div>
    </div>
  );
}

BrokerCommission.propTypes = {
  commission: PropTypes.shape({
    grossAmount: PropTypes.number.isRequired,
    grossPercent: PropTypes.number.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  transactionSide: PropTypes.string,
};
